import React from 'react'
import styles from './FluIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate } from './dates'
import Header from './Header'
import VulnerabilityBreakdown from './VulnerabilityBreakdown'
import SystemNotification from './../Dashboard/SystemNotification'
import BelowMapNotification from '../Dashboard/BelowMapNotification'
const VulnerabilityDashboard = () => {
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={"2025-01-01"}
              locationName={"US"}
              mapOptions={dataDisplayOptions[0]['options'][1]}
              indicatorName={dataDisplayOptions[0]['options'][1].indicatorName}
              regionSelected={'metro'}
            >
              <SystemNotification/>
              <Header headerType="nat" headerNumber={1} />
              <DashboardMap />
              <BelowMapNotification message_type='MONTHLY'/>
              <VulnerabilityBreakdown geo_type={"nat"} geo_id={"nat"}/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default VulnerabilityDashboard
